module.exports = __webpack_public_path__ + "img/100-Walnuss Terra - Wenge.jpg";